/* ==========================================================================
   Start Nutra · Reveal on scroll
   --------------------------------------------------------------------------
   Quietly fades in elements marked with [data-sn-reveal] when they enter
   the viewport. Honours prefers-reduced-motion (renders immediately).
   Honours no-JS / failed-JS (CSS gating via .js prefix keeps content
   visible unless the script is actually running).

   Usage:
     <div data-sn-reveal>...</div>
     <div data-sn-reveal data-sn-reveal-delay="100">...</div>  // ms
   ========================================================================== */

(function () {
  function snInitReveal() {
    var nodes = document.querySelectorAll('[data-sn-reveal]');
    if (!nodes.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach(function (el) { el.dataset.snRevealVisible = 'true'; });
      return;
    }

    if (typeof IntersectionObserver === 'undefined') {
      nodes.forEach(function (el) { el.dataset.snRevealVisible = 'true'; });
      return;
    }

    // Only NOW (script running, motion allowed, observer supported) do we arm
    // the hidden initial state, by flagging the root. The CSS hides
    // [data-sn-reveal] only under .sn-reveal-ready, so if this script never
    // runs (JS disabled or failed to load), nothing is ever hidden. The page's
    // <html> carries a hard-coded "js" class, so gating on that would hide
    // content permanently for no-JS users; this class is the correct gate.
    document.documentElement.classList.add('sn-reveal-ready');

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var delay = parseInt(entry.target.dataset.snRevealDelay || '0', 10);
        if (delay > 0) {
          setTimeout(function () { entry.target.dataset.snRevealVisible = 'true'; }, delay);
        } else {
          entry.target.dataset.snRevealVisible = 'true';
        }
        // Reveal once, then stop observing so it never re-animates on scroll-back.
        obs.unobserve(entry.target);
      });
      // Position-based trigger (threshold 0 + a bottom inset) instead of a ratio
      // threshold: fires when the element's top crosses ~12% up from the viewport
      // bottom: reliable even for sections taller than the viewport (a ratio
      // threshold can never be met by a very tall element), and it never fires
      // above the fold for below-fold content. Elements already on screen at load
      // intersect immediately on observe, so they reveal promptly.
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });

    nodes.forEach(function (el) { obs.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', snInitReveal);
  } else {
    snInitReveal();
  }
})();
